import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {GameLogic} from "../Logic/BlockCardsLogic";

export interface IButtonControllerOptions {
    label?: string;
    onClick: () => void;
}

export class ButtonController extends AnimationBaseController {
    $model: any;

    public constructor(
        @Inject private _options: IButtonControllerOptions,
        @Inject private _gameLogic: GameLogic
    ) {
        super("ButtonController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            onTap: () => {
                this._options.onClick();
                this.gotoAndStop("down");

            },
            onPointerDown: () => {
                this.gotoAndStop("down");
            },
            onPointerUp: () => {
                this.gotoAndStop("up");
            },
            onPointerOut: () => {
                this.gotoAndStop("up");
            },
            onPointerOver: () => {
                this.gotoAndStop("over");
            }
        };
    }

    protected onInitialize(): void {
        this.gotoAndStopByQuery("numbers", this.$model.index)
    }

    protected onAnimationEvent(name: string, ...args): void {
    }
}
